import ApprovalActionTypes from './approval.types';

const INITIAL_STATE = {};

const approvalReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default approvalReducer;
